import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Sparkles } from "lucide-react";

const bullets = [
  "150 crédits IA offerts dès l'inscription",
  "Génération de visuels & vidéos publicitaires",
  "Diffusion multi-réseaux en un clic",
];

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleButton = ({ label }) => {
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      onClick={handleGoogle}
      className="w-full h-11 rounded-xl border border-border bg-card hover:bg-secondary transition-colors flex items-center justify-center gap-3 font-medium text-sm"
      data-testid="google-auth-btn"
    >
      <svg className="h-5 w-5" viewBox="0 0 24 24">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
      </svg>
      {label}
    </button>
  );
};

export const AuthShell = ({ title, subtitle, children }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex bg-background">
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-12 bg-gradient-to-br from-indigo-600 via-indigo-700 to-cyan-600 relative overflow-hidden">
        <div className="absolute inset-0 mg-grid-bg opacity-20" />
        <Logo onClick={() => navigate("/")} />
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 text-white text-xs font-semibold mb-6">
            <Sparkles size={14} /> Propulsé par l'IA générative
          </div>
          <h1 className="font-display text-4xl font-extrabold text-white leading-tight mb-6">
            Créez des publicités e-commerce qui convertissent.
          </h1>
          <ul className="space-y-3">
            {bullets.map((b) => (
              <li key={b} className="flex items-center gap-3 text-white/90">
                <span className="h-6 w-6 rounded-full bg-white/20 flex items-center justify-center text-xs">✓</span>
                {b}
              </li>
            ))}
          </ul>
        </div>
        <p className="relative z-10 text-white/60 text-sm">« +312% de ROAS moyen sur nos campagnes » — Marque de mode</p>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md mg-fade-up">
          <div className="lg:hidden mb-8"><Logo onClick={() => navigate("/")} /></div>
          <h2 className="font-display text-3xl font-bold mb-1">{title}</h2>
          <p className="text-muted-foreground mb-8">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
};
